module.exports = __webpack_public_path__ + "img/Hidden-Number-1.2e9fa11f.svg";